import { IPaymentStatus } from "../../../../common/models/payment_status";

export enum StatusCardStatus {
    SUCCESS = "Success",
    ERROR = "Error",
    PENDING = "Pending",
    IN_PROGRESS = "In progress",
    CONFIRMED = "Confirmed",
    CANCELLED = "Cancelled"
  }

export enum StatusCardType {
    CUSTOMER_CONFIRMED = "CUSTOMER_CONFIRMED",
    CARD_NUMBER = "CARD_NUMBER",
    EXPIRY_DATE = "EXPIRY_DATE",
    CVV = "CVV",
    SUBMITTED = "SUBMITTED",
}

export const getDetailStatus = (detailSubmittedSuccessfully?: boolean, error?: boolean) => {
    if (error && !detailSubmittedSuccessfully) return StatusCardStatus.ERROR;
  
    if (detailSubmittedSuccessfully) return StatusCardStatus.SUCCESS;
  
    return StatusCardStatus.IN_PROGRESS;
};

export const getStatusCardStatus = (
    statusCard: StatusCardType,
    paymentStatus: IPaymentStatus | undefined,
    paymentSucceeded: boolean | undefined
) => {
    if (!paymentStatus) return StatusCardStatus.PENDING;
  
    const {
        CUSTOMER_CONFIRMED,
        CARD_NUMBER_ENTERED,
        CARD_NUMBER_ERROR,
        CARD_EXPIRY_ENTERED,
        CARD_EXPIRY_ERROR,
        CARD_CVV_ENTERED,
        CARD_CVV_ERROR,
    } = paymentStatus;
  
    switch (statusCard) {
        case StatusCardType.CUSTOMER_CONFIRMED:
            if (CUSTOMER_CONFIRMED === undefined) return StatusCardStatus.PENDING
            return CUSTOMER_CONFIRMED ? StatusCardStatus.CONFIRMED : StatusCardStatus.CANCELLED
        case StatusCardType.CARD_NUMBER:
            if (!CUSTOMER_CONFIRMED) {
                return StatusCardStatus.PENDING;
            }
            return getDetailStatus(CARD_NUMBER_ENTERED, CARD_NUMBER_ERROR);
        case StatusCardType.EXPIRY_DATE:
            if (!CARD_NUMBER_ENTERED) {
                return StatusCardStatus.PENDING;
            }
            return getDetailStatus(CARD_EXPIRY_ENTERED, CARD_EXPIRY_ERROR);
        case StatusCardType.CVV:
            if (!CARD_EXPIRY_ENTERED) {
                return StatusCardStatus.PENDING;
            }
            return getDetailStatus(CARD_CVV_ENTERED, CARD_CVV_ERROR);
        case StatusCardType.SUBMITTED:
            if (!CARD_CVV_ENTERED) {
                return StatusCardStatus.PENDING;
            }
            return getDetailStatus(
                paymentSucceeded === true,
                paymentSucceeded === false
            );
        default:
            return StatusCardStatus.PENDING;
    }
};
  